import ConstructionRounded from '@mui/icons-material/ConstructionRounded';
import TravelExploreRounded from '@mui/icons-material/TravelExploreRounded';
import { Card } from '@mui/material';
import { useLocation, useNavigate } from 'react-router';
import { EmptyState, PageHeader } from '../components/states';
import { NAV } from '../layout/nav';

/** Placeholder for nav screens not built yet, and the not-found page for unknown paths. */
export function ComingSoonPage() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const item = NAV.flatMap((g) => g.items).find((i) =>
    i.path === '/' ? pathname === '/' : pathname === i.path || pathname.startsWith(`${i.path}/`),
  );
  return (
    <>
      <PageHeader title={item?.label ?? 'Page not found'} />
      <Card>
        <EmptyState
          icon={item ? <ConstructionRounded /> : <TravelExploreRounded />}
          title={item ? 'This screen is on its way' : 'Nothing lives at this address'}
          body={
            item
              ? `${item.label} is being built for the platform console. The rest of the console is ready to use.`
              : 'The page you were looking for does not exist or has moved.'
          }
          action={
            pathname === '/'
              ? undefined
              : { label: 'Back to dashboard', onClick: () => void navigate('/') }
          }
        />
      </Card>
    </>
  );
}
